import { useState, useEffect } from 'react';
import IconChevronUpLarge from '@picsart/icons/IconChevronUpLarge';
import IconChevronDownLarge from '@picsart/icons/IconChevronDownLarge';
import { useTranslation } from 'react-i18next';

import { IRephrasedResult, ToolCategory, ResultType } from '../../../../utils/common/types';
import AiWriterResult from '../../../resultsSections/AiWriterResult';
import analytics from '../../../../services/analytics';
import { getCategoryName } from '../../../../utils/common/category';
import LoadingRephrasedResults from '../LoadingRephrasedResults';
import { MAIN_CONTENT_ID } from '../../../../constants';

import useStyles from './styles';

type RephrasedProps = {
  canBeSavedToRecents?: boolean;
  rephrasedResults: IRephrasedResult[];
  originalTextIndex: number;
  showWordCount: boolean;
  isLoading: boolean;
  category: ToolCategory;
};

function Rephrased({
  rephrasedResults,
  showWordCount,
  isLoading,
  canBeSavedToRecents,
  category,
}: RephrasedProps) {
  const { t } = useTranslation();
  const [showText, setShowText] = useState(true);
  const classes = useStyles({ showText });

  const handleClick = () => {
    analytics.resultsAction({
      page_path: window.location.pathname,
      action_type: showText ? 'rephrase_collapse' : 'rephrase_open',
      category_name: getCategoryName(category),
    });

    setShowText((prev) => !prev);
  };

  useEffect(() => {
    if (showText && !isLoading) {
      const container = document.getElementById(MAIN_CONTENT_ID).parentElement;

      container.scrollBy({ top: 25, behavior: 'smooth' });
    }
  }, [showText, isLoading]);

  return (
    <div className={classes.root}>
      <div className={classes.header} onClick={handleClick}>
        {t('editor.rephrased')}
        {showText ? <IconChevronUpLarge /> : <IconChevronDownLarge />}
      </div>
      {isLoading ? (
        <LoadingRephrasedResults />
      ) : showText ? (
        <>
          {rephrasedResults.map((item, index) => (
            <AiWriterResult
              id={item.id}
              key={item.id}
              index={index}
              type={ResultType.Rephrase}
              category={category}
              canBeSavedToRecent={canBeSavedToRecents}
              markdown={item.result}
              showWordCount={showWordCount}
            />
          ))}
        </>
      ) : null}
    </div>
  );
}
export default Rephrased;
